<template>
  <div class="release_public">
    <div class="top_title flex Flexalign FlexBetween">
      <div class="flex Flexalign">
        <div class="cursor_pointer" @click="releasePublic">讨论组 ></div>
        <div class="release_public_text">发布主题</div>
      </div>
      <div class="Flexalign flex use_rule">
        <div>使用规则</div>
        <el-image class="green_doubt_icon" :src="iconPath('green_doubt_icon.png')"></el-image>
      </div>
    </div>
    <div class="public_box mar_top_20">
      <div class="flex belong_sector Flexalign">
        <div class="red_xing">*</div>
        <div>所属讨论板块</div>
      </div>
    </div>
    <div class="public_box mar_top_15">
      <div class="flex belong_sector Flexalign">
        <div class="red_xing"></div>
        <el-select v-model="publicValue" placeholder="Select" size="large" style="width: 270px; height: 38px">
          <el-option v-for="item in publicOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
    </div>
    <div class="public_box mar_top_20">
      <div class="flex belong_sector Flexalign">
        <div class="red_xing">*</div>
        <div>内容</div>
      </div>
    </div>
    <div class="public_box mar_top_15">
      <div class="flex belong_sector Flexalign">
        <!-- <div class="red_xing"></div> -->
        <!-- <Editor
          :content="textContent"
          @contentData="getPrivacyAgreement"
        ></Editor> -->
        <!-- <quill-editor ref="editorRef" v-model:content="questionInfo.content" :options="editorOption" contentType="html"
          @getHtml="getHtml"></quill-editor> -->
        <!-- <div class="question_content flex flexcolumn mar_left_10 flex-1">
          <el-input
            v-model="questionInfo.content"
            style="width: 100%; min-height: 80px"
            autosize
            type="textarea"
            placeholder="你可以向大家提问，或者分享学习心得，发布讨论可获得5积分。"
          />
          <div class="flex Flexalign FlexBetween upload_box">
            <el-upload
              v-model:file-list="questionInfo.imgList"
              action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
              list-type="picture-card"
              :on-remove="handleRemove"
            >
              <el-image
                class="img_upload_icon"
                :src="iconPath('img_upload_icon.png')"
              ></el-image>
            </el-upload>
            <div
              class="commit_btn"
              :class="[questionInfo.content ? 'active_commit_btn' : '']"
              @click="commitDiscuss"
            >
              发布
            </div>
          </div>
        </div> -->
        <div class="flex Flexalign question_box">
          <!-- <el-image class="avatar" :src="userInfo.headImage"></el-image> -->
          <div class="question_content flex flexcolumn mar_left_10 flex-1">
            <el-input v-model="questionInfo.content" style="width: 100%; min-height: 80px;max-height: 300px;overflow: auto;" autosize type="textarea"
              placeholder="你可以向大家提问，或者分享学习心得，发布讨论可获得5积分。" />
            <div class="flex Flexalign FlexBetween upload_box mt-10">
              <el-upload v-model:file-list="imgList" :action="uploadUrl" list-type="picture-card"
                :on-remove="handleRemove" :before-upload="handleChange">
                <el-image class="img_upload_icon" :src="iconPath('img_upload_icon.png')"></el-image>
              </el-upload>
              <div class="commit_btn cursor_pointer" :class="[questionInfo.content ? 'active_commit_btn' : '']"
                @click="commitDiscuss">
                发布
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="public_box mar_top_15">
      <div class="commit_btn cursor_pointer" :class="[questionInfo.content ? 'active_commit_btn' : '']"
        @click="commitDiscuss">
        发布
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as config from "@/config/config";
// import quillEditor from "@/components/editor/index.vue";
export default {
  name: "GjkcH5ReleasePublic",
  components: {
    // quillEditor,
  },
  props: {
    courseId: {},
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      publicOptions: [
        {
          value: 1,
          label: "老师答疑区",
        },
        {
          value: 2,
          label: "课堂交流区",
        },
        {
          value: 3,
          label: "综合讨论区",
        },
      ],
      publicValue: 1,
      content: "", //富文本的内容
      editorOption: {
        theme: "snow", // 使用snow主题
        modules: {
          // 富文本头部栏的功能配置
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ align: [] }], // 对齐方式
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ font: [] }], // 字体种类
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              [{ direction: "ltl" }], // 文本方向
              [{ direction: "rtl" }], // 文本方向
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
              [{ script: "sub" }, { script: "super" }], // 上标/下标
              ["blockquote", "code-block"], // 引用  代码块
              ["clean"], // 清除文本格式
              ["link", "image", "video"], // 链接、图片、视频
            ],
            // handlers: {
            //   image: imageHandler, // 点击图片触发事件
            // },
          },
          // 图片缩放
          blotFormatter: {
            // 可以在这里设置缩放样式
            // overlay: {
            //    style: {
            //        border: '2px solid red',
            //    }
            // },
            toolbar: {
              mainClassName: "blot-formatter__toolbar",
            },
          },
        },
      },
      questionInfo: {
        classify: "", //1=老师答疑区，2=课堂交流区，3=综合讨论区
        content: "",
        courseId: "",
        imgs: [],
      },
      imgList:[],
      uploadUrl: "",
      submitFlag:false,   // 用于处理重复点击
    };
  },

  mounted() {
    this.uploadUrl = config.COMMON_UPLOAD_URL;
   },

  methods: {
    // 上传图片
    handleChange(uploadFile, uploadFiles) {
      console.log(uploadFile.url, uploadFiles);
      // this.$Api.common
      //   .uploadFile(uploadFile.url)
      //   .then((res) => {
      //     console.log(res);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    handleRemove(uploadFile, uploadFiles) {
      console.log(uploadFile, uploadFiles);
    },
    //富文本内容输出
    getPrivacyAgreement(val) {
      console.log(val);
    },
    // 发布讨论
    commitDiscuss() {
      if(this.submitFlag) return;
      this.submitFlag = true;
      this.questionInfo.courseId = this.courseId;
      if (!this.questionInfo.content) {
        this.$Dialog.toast("请输入提问内容", { type: "warning" });
        return;
      }
      if (this.publicValue == "") {
        this.$Dialog.toast("请选择答疑板块", { type: "warning" });
        return;
      }
      this.questionInfo.classify = this.publicValue;
      let questionImgs = [];
      if (this.imgList.length) {
        this.imgList.forEach((item) => {
          questionImgs.push(item.response?.data?.url)
        });
      }
      this.questionInfo.imgs = questionImgs.join(',');
      this.$Api.course
        .addDiscuss(this.questionInfo)
        .then((res) => {
          console.log(res);
          this.$Dialog.toast("发布成功");
          this.questionInfo.content = "";
          this.releasePublic();
        })
        .catch(() => {
            this.submitFlag = false;
        });
    },
    releasePublic() {
      this.$emit("releasePublicChange", false);
    },
    getHtml(value) {
      this.questionInfo.content = ''
      const isEmptyEditorHtml = html =>
        /^<p>(<br>|<br\/>|<\/?p>|\s)*<\/?p>$/i.test(html.trim());
      if (isEmptyEditorHtml(value)) return
      this.questionInfo.content = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.release_public {
  width: 762px;
  max-height: 770px;
  padding: 15px 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 10px;

  .top_title {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    padding-bottom: 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #dedede;

    .release_public_text {
      color: #999999;
    }

    .use_rule {
      font-size: 14px;
      color: #13d6aa;

      .green_doubt_icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .public_box {
    .belong_sector {
      font-size: 18px;
      color: #333333;

      .question_box {
        width: 100%;
        margin-bottom: 20px;

        .avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
        }

        .question_content {
          width: 100%;
          min-height: 117px;
          background: #f7f7f7;
          border-radius: 10px;
          position: relative;
          padding: 10px 0;

          :deep(.el-textarea__inner) {
            background: #f7f7f7;
            box-shadow: none;
            resize: none;
          }

          .upload_box {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;

            // position: absolute;
            // bottom: 10px;
            :deep(.el-upload--picture-card) {
              width: auto;
              height: auto;
              border: none;
            }

            .img_upload_icon {
              width: 24px;
              height: 24px;
            }

            .commit_btn {
              width: 64px;
              height: 32px;
              background: #c2c2c2;
              border-radius: 16px;
              color: #ffffff;
              line-height: 32px;
              text-align: center;
            }

            .active_commit_btn {
              background: linear-gradient(90deg, #00d5c2, #00d498);
            }
          }
        }
      }

      .red_xing {
        color: #fd0c0c;
        width: 20px;
        height: 18px;
      }

      .question_content {
        // width: 100%;
        min-height: 117px;
        background: #f7f7f7;
        border-radius: 10px;
        position: relative;

        :deep(.el-textarea__inner) {
          background: #f7f7f7;
          box-shadow: none;
          resize: none;
        }

        .upload_box {
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;

          // position: absolute;
          // bottom: 10px;
          :deep(.el-upload--picture-card) {
            width: auto;
            height: auto;
            border: none;
          }

          .img_upload_icon {
            width: 24px;
            height: 24px;
          }

          .commit_btn {
            width: 64px;
            height: 32px;
            background: #c2c2c2;
            border-radius: 16px;
            color: #ffffff;
            line-height: 32px;
            text-align: center;
          }

          .active_commit_btn {
            background: linear-gradient(90deg, #00d5c2, #00d498);
          }
        }
      }
    }

    .commit_btn {
      width: 200px;
      height: 48px;
      border-radius: 24px;
      background: #c2c2c2;
      color: #ffffff;
      line-height: 48px;
      text-align: center;
      font-size: 18px;
    }

    .active_commit_btn {
      background: linear-gradient(90deg, #00d5c2, #00d498);
    }
  }
}
</style>
